import { languages } from 'monaco-editor-core';

export const config: languages.LanguageConfiguration = {
  brackets: [
    ['{', '}'],
    ['[', ']'],
    ['(', ')'],
  ],
  autoClosingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
  ],
  surroundingPairs: [
    { open: '{', close: '}' },
    { open: '[', close: ']' },
    { open: '(', close: ')' },
    { open: '"', close: '"' },
  ],
};

export const grammar = <languages.IMonarchLanguage>{
  defaultToken: 'invalid',
  ignoreCase: true,
  escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,

  operators: ['AND', 'OR', 'NOT', 'TO', 'exists', '&&', '||'],

  brackets: [
    { open: '[', close: ']', token: 'delimiter.square' },
    { open: '(', close: ')', token: 'delimiter.parenthesis' },
    { open: '{', close: '}', token: 'delimiter.parenthesis' },
  ],

  tokenizer: {
    root: [
      { include: '@whitespace' },
      { include: '@numbers' },
      { include: '@operators' },
      { include: '@brackets' },
      { include: '@keywords' },
      { include: '@strings' },
      [
        /[\w]+/,
        {
          cases: {
            '@operators': 'operator',
            '@default': 'string',
          },
        },
      ],
    ],
    whitespace: [[/\s+/, 'white']],
    numbers: [
      [/(([0-9]*[.])?[0-9]+([\s]*)*)+(($)|[\s$])/, 'number'],
      [/([0-9]*[.])?[0-9]+/, 'string'],
    ],
    operators: [
      [/[~*-:\+]/, 'operator'],
      [/[\?]+/, 'operator'],
      [/&&/, 'operator'],
      [/\|\|/, 'operator'],
    ],
    brackets: [[/[(){}\[\]]/, '@brackets']],
    keywords: [[/([\w\.\&]+\s*)(?=\s*:)/, 'keyword']],
    strings: [
      [/"([^"\\]|\\.)*$/, 'string.invalid'], // non-teminated string
      [/"/, 'string', '@string_double'],
    ],
    string_double: [
      [/[^\\"]+/, 'string'],
      [/@escapes/, 'string.escape'],
      [/\\./, 'string.escape.invalid'],
      [/"/, 'string', '@pop'],
    ],
  },
};
